import '@hotwired/turbo-rails';
import { visit, StreamActions } from '@hotwired/turbo';

StreamActions.visit = function() {
  const url = this.getAttribute("target");

  if (url) {
    visit(url);
  }
};
